//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Issue.js";
import "../no/NXObject.js";
let d=[[],[[[],"ReloadIssues",{},0,0],[["nIssues"],"GetIssues",{R_:{issues:"Issue.IssueContent[]"}},0,0],[[],"ExistsInDatabase",{R_:{exists:''}},0,0],[[],"SaveChanges",{},0,0],[[],"DiscardChanges",{},0,0],[[],"SaveConfig",{},0,0],[[],"ResetConfig",{},0,0],[["queryName","criteriaTitles","criteriaValues"],"ChangeConfig",{},3,0],[["parts"],"SetRelatedParts",{},1,0]],[]];
SPLM.Issue.IssueList = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Issue.IssueList";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;